import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the IndexOfPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'indexOf',
})
export class IndexOfPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(array, value) {
    try {
      return array.indexOf(value);
    } catch (e) {
      return -1;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/index-of/index-of.ts